import React, { useEffect, useState } from 'react';
import { useClient } from 'jsonapi-react';
import toast from 'react-hot-toast';
import { VscGame } from 'react-icons/vsc';
import checkIcon from './img/check-icon.svg';
import xIcon from './img/x-icon.svg';
import { useWeeklyChallenge } from '@/hooks/useWeeklyChallenge';
import { Loader } from '@/components/custom/loader';
import {
  ChallengeQuestion,
  ChallengeQuestionAlternative,
  ChallengeQuestionBody,
  ChallengeQuestionCount,
  ChallengeQuestionHeader,
  ChallengeQuestionIcon,
  ChallengeQuestionList,
  ChallengeQuestionRadio,
  ChallengeQuestionTitle
} from '@/components/custom/challenge';

export function DuelsPlayerQuestion() {
  const client = useClient();
  const { currentChallenge, loading, setStart, counter, setCurrentStep, setRightAnswers, questions, getQuestions, currentRound } = useWeeklyChallenge();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [currentAnswer, setCurrentAnswer] = useState(null);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [correctAlternativeId, setCorrectAlternativeId] = useState();

  const handleAnswerQuestion = async alternativeId => {
    setSelectedAnswer(alternativeId);
    setStart(false);
    setIsSubmitting(true);

    const payload = {
      selected_alternative_id: alternativeId,
      question_id: questions?.id
    };

    await client
      .mutate(`/duels/${currentChallenge.id}/answer`, payload, { method: 'PUT' })
      .then(response => {
        const currentAnswer = questions?.id;
        setCurrentAnswer(currentAnswer);
        setCorrectAlternativeId(response?.data?.question?.['correct_alternative_id']);
        if (alternativeId === response?.data?.question?.['correct_alternative_id']) {
          setRightAnswers(prev => prev + 1);
        }
        setTimeout(() => {
          setCurrentStep(3);
        }, 3000);
      })
      .catch(err => {
        toast.error('Erro ao responder questão');
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  useEffect(() => {
    if (counter === 0) {
      handleAnswerQuestion(null, 'skipped');
    }
  }, [counter]);

  useEffect(() => {
    getQuestions();
  }, [currentRound]);

  const getVariant = itemId => {
    if (selectedAnswer && correctAlternativeId) {
      if (selectedAnswer === itemId) {
        return selectedAnswer === correctAlternativeId ? 'success' : 'danger';
      }
    }
    return null;
  };

  const getIcon = itemId => {
    if (selectedAnswer && correctAlternativeId) {
      if (correctAlternativeId === itemId) {
        return (
          <ChallengeQuestionIcon
            src={checkIcon}
            alt="ícone de marcado"
          />
        );
      } else if (selectedAnswer === itemId) {
        return (
          <ChallengeQuestionIcon
            src={xIcon}
            alt="ícone de errado"
          />
        );
      }
    }
    return null;
  };

  if (loading) return <Loader />;

  return (
    <ChallengeQuestion>
      <ChallengeQuestionCount>
        <VscGame /> {currentRound}
      </ChallengeQuestionCount>

      <ChallengeQuestionHeader>
        <ChallengeQuestionTitle>{questions?.content}</ChallengeQuestionTitle>
      </ChallengeQuestionHeader>

      <ChallengeQuestionBody>
        <ChallengeQuestionList>
          {questions?.alternatives?.map(item => {
            return (
              <ChallengeQuestionAlternative
                key={item?.id}
                disabled={isSubmitting}
                variant={getVariant(item.id)}
                onClick={() => {
                  handleAnswerQuestion(item?.id);
                }}
              >
                <ChallengeQuestionRadio /> {item?.['alternative_text']}
                {getIcon(item.id)}
              </ChallengeQuestionAlternative>
            );
          })}
        </ChallengeQuestionList>
      </ChallengeQuestionBody>
    </ChallengeQuestion>
  );
}
